var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"library-main",class:_vm.directionSystem,attrs:{"id":"app"},on:{"click":function($event){return _vm.toggleBaseLibraryMenu(null)}}},[(_vm.showLoader)?_c('library-loader'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }